export const SERVER_BACKED_TURN_PATIENCE_MS = 8 * 60 * 1000;
export const CLIENT_ONLY_TURN_PATIENCE_MS = 25 * 1000;

export function selectTurnPatienceTimeoutMs(
  responseMode: 'stream' | 'async' | 'auto',
): number {
  if (responseMode === 'async') {
    return CLIENT_ONLY_TURN_PATIENCE_MS;
  }
  return SERVER_BACKED_TURN_PATIENCE_MS;
}

export function formatElapsedTurnDuration(elapsedMs: number): string {
  const safeElapsed = Number.isFinite(elapsedMs) ? Math.max(0, elapsedMs) : 0;
  const totalSeconds = Math.floor(safeElapsed / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}m ${seconds}s`;
}

/** Compact clock form for inline indicators: 0:02, 1:05, 12:40. */
export function formatElapsedTurnDurationCompact(elapsedMs: number): string {
  const safeElapsed = Number.isFinite(elapsedMs) ? Math.max(0, elapsedMs) : 0;
  const totalSeconds = Math.floor(safeElapsed / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

/**
 * Progress-pill label (redesigned per owner feedback, Miles 2026-07-12):
 * compact — `<stage> · 0:42` — instead of the old wordy
 * "<stage> - still working... (0m 42s elapsed)". The old form also DUPLICATED
 * itself ("still working - still working…") because the ticker seeds the
 * stage label with the literal 'still working' default and the builder
 * appended its own copy. Generic/empty stage labels collapse to `working`.
 */
export function buildServerBackedProgressLabel(
  stageLabel: string | undefined,
  elapsedMs: number,
): string {
  const elapsed = formatElapsedTurnDurationCompact(elapsedMs);
  const cleanLabel = (stageLabel || '').trim();
  const isGeneric = !cleanLabel || /^(still\s+)?working(\.{0,3})?$/i.test(cleanLabel);
  if (isGeneric) {
    return `working · ${elapsed}`;
  }
  return `${cleanLabel} · ${elapsed}`;
}
